"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.verifySupport = void 0;
var verifySupport = exports.verifySupport = function verifySupport() {
  var _process;
  if (typeof window === 'undefined' && ((_process = process) === null || _process === void 0 || (_process = _process.config) === null || _process === void 0 ? void 0 : _process.variables).icu_small) {
    // eslint-disable-next-line no-console
    console.warn('WARNING: your node.js is build with --with-intl=small-icu.\n' + 'Please use node.js with --with-intl=full-icu for full language support');
  }
};
//# sourceMappingURL=utils.js.map